/**
 * Map raw RTK Query errors from qriots-api into a small enum the screens
 * can switch on. Keeps screens free of magic status numbers.
 */

export type QriotsErrorKind =
  | 'not_found'
  | 'rate_limited'
  | 'auth'
  | 'network'
  | 'server'
  | 'unknown';

export interface ClassifiedQriotsError {
  kind: QriotsErrorKind;
  retryAfterSec?: number;
}

export function classifyQriotsError(err: unknown): ClassifiedQriotsError {
  const e = err as {
    status?: number | string;
    data?: { error?: string; retryAfter?: number };
  };
  if (e?.status === 'FETCH_ERROR' || e?.status === 'TIMEOUT_ERROR') {
    return { kind: 'network' };
  }
  if (e?.status === 401) return { kind: 'auth' };
  if (e?.status === 404) return { kind: 'not_found' };
  if (e?.status === 429) {
    return { kind: 'rate_limited', retryAfterSec: e?.data?.retryAfter ?? 5 };
  }
  if (typeof e?.status === 'number' && e.status >= 500) return { kind: 'server' };
  return { kind: 'unknown' };
}
